<!-- ANCHOR: Full-screen structure flow dialog -->
<dialog
  #dialogEl
  class="app-tree-dialog"
  [attr.aria-label]="'chatbot.tree.title' | translate"
  aria-modal="true"
  (click)="onDialogClick($event, dialogEl)"
  (cancel)="onCancel($event)"
>
  <!-- Header -->
  <div class="app-tree-dialog__header">
    <div class="app-tree-dialog__title">
      <i class="fas fa-code-branch" aria-hidden="true"></i>
      {{ 'chatbot.tree.title' | translate }}
    </div>
    <p class="app-tree-dialog__subtitle">{{ 'chatbot.tree.subtitle' | translate }}</p>
    <button
      type="button"
      class="app-tree-dialog__close"
      [attr.aria-label]="'chatbot.aria-close' | translate"
      (click)="close()"
    >
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <!-- Flow chart body -->
  <div class="app-tree-dialog__body">
    <div class="app-flow">

      <!-- Branch row: one card per group -->
      <div class="app-flow__branch-row">
        @for (group of groups(); track group.id) {
          <div class="app-flow__branch" [class.app-flow__branch--large]="group.totalItems >= 9">

            <!-- Group node (header of the branch) -->
            <div class="app-flow__group-node">
              <i class="fas {{ group.icon }}" aria-hidden="true"></i>
              <span>{{ group.labelKey | translate }}</span>
            </div>

            <!-- Connector between group node and leaves -->
            <div class="app-flow__group-stem"></div>

            <!-- Leaf nodes (supports one level of parent → child nesting) -->
            <div class="app-flow__leaves">
              @for (node of group.sections; track node.section.id) {
                @if (node.children.length === 0) {
                  @if (node.section.navigable === false) {
                    <div class="app-flow__leaf app-flow__leaf--no-link">
                      <i class="fas {{ node.section.icon }}" aria-hidden="true"></i>
                      <span class="app-flow__leaf-label">{{ node.section.labelKey | translate }}</span>
                      <span class="app-flow__leaf-desc">{{ node.section.descKey | translate }}</span>
                    </div>
                  } @else {
                    <button
                      type="button"
                      class="app-flow__leaf"
                      [attr.aria-label]="('chatbot.map.navigate' | translate) + ' ' + (node.section.labelKey | translate)"
                      (click)="goTo(node.section.payload)"
                    >
                      <i class="fas {{ node.section.icon }}" aria-hidden="true"></i>
                      <span class="app-flow__leaf-label">{{ node.section.labelKey | translate }}</span>
                      <span class="app-flow__leaf-desc">{{ node.section.descKey | translate }}</span>
                    </button>
                  }
                } @else {
                  <div class="app-flow__section-parent">
                    @if (node.section.navigable === false) {
                      <div class="app-flow__leaf app-flow__leaf--has-children app-flow__leaf--no-link">
                        <i class="fas {{ node.section.icon }}" aria-hidden="true"></i>
                        <span class="app-flow__leaf-label">{{ node.section.labelKey | translate }}</span>
                        <span class="app-flow__leaf-desc">{{ node.section.descKey | translate }}</span>
                      </div>
                    } @else {
                      <button
                        type="button"
                        class="app-flow__leaf app-flow__leaf--has-children"
                        [attr.aria-label]="('chatbot.map.navigate' | translate) + ' ' + (node.section.labelKey | translate)"
                        (click)="goTo(node.section.payload)"
                      >
                        <i class="fas {{ node.section.icon }}" aria-hidden="true"></i>
                        <span class="app-flow__leaf-label">{{ node.section.labelKey | translate }}</span>
                        <span class="app-flow__leaf-desc">{{ node.section.descKey | translate }}</span>
                      </button>
                    }
                    <div class="app-flow__section-children">
                      @for (child of node.children; track child.id) {
                        <button
                          type="button"
                          class="app-flow__child-leaf"
                          [title]="child.descKey | translate"
                          [attr.aria-label]="('chatbot.map.navigate' | translate) + ' ' + (child.labelKey | translate)"
                          (click)="goTo(child.payload)"
                        >
                          <i class="fas {{ child.icon }}" aria-hidden="true"></i>
                          <span class="app-flow__child-label">{{ child.labelKey | translate }}</span>
                        </button>
                      }
                    </div>
                  </div>
                }
              }
            </div>

          </div>
        }
      </div>

    </div>
  </div>
</dialog>
